export enum ExportTypesEnum {
  SALES_EXPORT_HECHENDORF = '0',
}

export enum ExportTypesTranslationsEnum {
  SALES_EXPORT_HECHENDORF = 'Umsatzexport Hechendorf',
}
